let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("feDrV")).then(() => parcelRequire('aYRJ2'));